import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentEngagementAnalytics from "./routes/StudentEngagementAnalytics";
import FamilyEngagementAnalytics from "./routes/FamilyEngagementAnalytics";
import StaffEngagementAnalytics from "./routes/StaffEngagementAnalytics";
export default store => {
  return {
    path: "engagement",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "engagement" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      StaffEngagementAnalytics(store),
      StudentEngagementAnalytics(store),
      FamilyEngagementAnalytics(store),
    ],
  };
};
